import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from "uuid";
import { setGreaseAnswer } from '../../Redux/Slices/User/greaseAnswers';
import RadioButton from 'Components/RadioButton';
import Add from "../../Assets/Svg/Admin/AssessmentBacklog/add.svg";
import { MdDeleteOutline } from "react-icons/md";

const GreaseType = ({
  questions,
  savedAnswers,
  onNotesChange,
  notes: parentNotes,
  categoryIndex,
  subCategoryIndex,
  questionIndex,
  onValidationChange,  // NEW prop to send validation status to parent,
  sendErrorToChild,
  setSendErrorToChild,
}) => {
  const questionData = questions?.questions?.[0];
  const [localNotes, setLocalNotes] = useState(parentNotes || "");
  const [radioVal, setRadioVal] = useState("no");
  const [groups, setGroups] = useState([]);
  const [errors, setErrors] = useState([]);
  const [touched, setTouched] = useState([]);

  const dispatch = useDispatch();

  const radioOption = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];

  useEffect(() => {
    if (!questionData?.options) return;

    if (savedAnswers && savedAnswers.length > 0 && savedAnswers[0]?.option_id) {
      // group answers 2 by 2
      const groupedAnswers = [];
      for (let i = 0; i < savedAnswers.length; i += 2) {
        groupedAnswers.push(savedAnswers.slice(i, i + 2));
      }

      setRadioVal("yes");

      const restoredGroups = groupedAnswers.map(group =>
        questionData.options.map((opt, idx) => {
          const saved = group.find(ans => ans.option_id === opt.option_id);

          return {
            uuid: uuidv4(),
            optionId: opt.option_id,
            title: opt.title,
            textAnswer:
              idx === 0 ? saved?.grease_name || "" :
                idx === 1 ? saved?.grease_size || "" :
                  "",
          };
        })
      );

      setGroups(restoredGroups);
    }
  }, [savedAnswers, questionData]);


  const handleRadioChange = (e) => {
    const value = e?.target?.value;
    setRadioVal(value);
    if (value !== "yes") {
      setGroups([]);
      dispatch(setGreaseAnswer({ questionId: questionData.question_id, answers: [] }));
    } else {
      if (groups.length === 0 && questionData?.options) {
        const initialGroup = questionData.options.map((opt) => ({
          uuid: uuidv4(),
          optionId: opt.option_id,
          title: opt.title,
          textAnswer: "",
        }));
        setGroups([initialGroup]);
      }
    }
  };

  const handleNewOptionsGroup = () => {
    if (!questionData?.options) return;

    const newGroup = questionData.options.map((opt) => ({
      uuid: uuidv4(),
      title: opt.title,
      optionId: opt.option_id,
      textAnswer: "",
    }));

    setGroups((prev) => [...prev, newGroup]);
    setTouched((prev) => [...prev, newGroup.map(() => false)]);
  };

  const handleDeleteOptionsGroup = (index) => {
    if (!questionData?.options) return;

    const afterDeleteGroup = groups.filter((_, ind) => ind !== index);
    setGroups(afterDeleteGroup);
  };

  useEffect(() => {
    if (parentNotes !== localNotes) {
      setLocalNotes(parentNotes || "");
    }
  }, [parentNotes]);

  const handleNotesChange = (e) => {
    const value = e.target.value;
    setLocalNotes(value);
    onNotesChange(categoryIndex, subCategoryIndex, questionIndex, "notes", e);
  };

  // Update redux with grease answers whenever groups change
  useEffect(() => {
    if (!questionData?.question_id) return;

    if (radioVal !== "yes") {
      dispatch(setGreaseAnswer({ questionId: questionData.question_id, answers: [] }));
      return;
    }

    const answers = groups.flatMap((group) =>
      group.map((opt, idx) => {
        if (idx === 0) {
          return { optionId: opt.optionId, greaseName: opt.textAnswer || "" };
        }
        if (idx === 1) {
          return { optionId: opt.optionId, greaseSize: opt.textAnswer || "" };
        }
        return null;
      }).filter(Boolean)
    );

    dispatch(setGreaseAnswer({
      questionId: questionData.question_id,
      answers,
    }));
  }, [groups, dispatch, questionData, radioVal]);


  return (
    <div className="question-item mb-4">
      <h4>{questionData?.question_id}. {questionData?.question}</h4>

      {/* radio buttons */}
      <div className="option-items">
        {radioOption.map((item) => (
          <div className="option-item" key={item.value}>
            <RadioButton
              label={item.label}
              value={item.value}
              onChange={handleRadioChange}
              isSelected={radioVal === item.value}
              name="greaseType"
            />
          </div>
        ))}
      </div>

      {radioVal === "yes" && (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div style={{ width: "100%" }}>
            {groups.map((group, groupIdx) => (
              <div key={groupIdx} className="options-group mb-4">
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <div
                    className="add-user-add-button"
                    onClick={handleNewOptionsGroup}
                    style={{ marginBottom: "16px", cursor: "pointer" }}
                  >
                    <img src={Add} alt="Add" />
                  </div>
                  {groupIdx !== 0 && (
                    <div
                      className="add-user-add-button"
                      style={{ marginBottom: "16px", cursor: "pointer", width: "40px", height: "40px" }}
                    >
                      <MdDeleteOutline
                        onClick={() => handleDeleteOptionsGroup(groupIdx)}
                        color="#ffff"
                        style={{
                          width: "40px",
                          height: "40px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#1f2155",
                          borderRadius: "50%",
                        }}
                        size={25}
                        className="remove-icon"
                      />
                    </div>
                  )}
                </div>

                {group.map((opt, idx) => (
                  <div key={opt.uuid} className="option-items mb-3">
                    <h5>{opt.title}</h5>
                    <textarea
                      style={{
                        resize: "none",
                        padding: "8px",
                      }}
                      placeholder="Enter answer here..."
                      className="answer-input"
                      value={opt.textAnswer || ""}
                      onChange={(e) => {
                        const updatedGroups = [...groups];
                        updatedGroups[groupIdx][idx].textAnswer = e.target.value;
                        setGroups(updatedGroups);
                        setSendErrorToChild(false);
                      }}
                    />
                    {
                      sendErrorToChild && !opt.textAnswer && (
                        <div style={{ color: "red", padding: "2px" }}>
                          This is a required field
                        </div>
                      )
                    }
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* notes */}
      <div className="option-items mt-3">
        <h4>Add your notes</h4>
        <textarea
          placeholder="Enter here..."
          className="notes-input"
          value={localNotes}
          onChange={handleNotesChange}
        />
      </div>
    </div>
  );
};

export default GreaseType;
